import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { DocumentsService } from "@services/documents.service";


@Injectable()
export class DocumentsResolver {
  constructor(
    private documentsSrv: DocumentsService,
    private uiSrv: UiService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
    this.uiSrv.routeLoadingStateChanged.next(true);

    return this.documentsSrv.get()
      .pipe(
        tap(() => {
          this.uiSrv.routeLoadingStateChanged.next(false);
        })
      );
  }
}
